import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../../api";
import { HttpError, UserReadModel } from "../../../api/types";
import useShowToast from "../../../hooks/useShowToast";

/**
 * Custom hook to fetch the users list from backend.
 * @returns {object} - Contains users, loading state, error state, and refetch function.
 */
function useFetchUsers() {
  const { t } = useTranslation();
  const [users, setUsers] = useState<UserReadModel[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<HttpError | null>(null);
  const { errorToast } = useShowToast();

  const fetchUsers = async () => {
    setLoading(true);
    setError(null);

    try {
      const users = await api.getManagementUsers();

      if (api.error) {
        setError(api.error);
        errorToast({
          title: t("club_management.users.fetch.error_title"),
          description: t("club_management.users.fetch.error_description"),
        });
      }

      setUsers(users || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return {
    users,
    loading,
    error,
    refetchUsers: fetchUsers,
  };
}

export default useFetchUsers;
